import { type CSSObject } from '@emotion/react'
// Scoped to the business route so navigation cannot change other pages.
export const businessCss: CSSObject = {
	'--ink': '#202c2a',
	'--muted': '#66716b',
	'--paper': '#f6f5ee',
	'--line': '#d7dbd0',
	'--green': '#203e33',
	'--lime': '#d9ee8b',
	'--orange': '#c94f29',
	'& *': {
		boxSizing: 'border-box',
	},
	margin: '0',
	background: 'var(--paper)',
	color: 'var(--ink)',
	font: '16px/1.55 var(--font-family)',
	'& button, & a, & input': {
		font: 'inherit',
	},
	'& button': {
		cursor: 'pointer',
		color: 'inherit',
	},
	'& a': {
		color: 'inherit',
		textDecoration: 'none',
	},
	'& button:focus-visible, & a:focus-visible': {
		outline: '3px solid #d86635',
		outlineOffset: '5px',
	},
	'& h1, & h2, & h3, & p': {
		margin: '0',
	},
	'& h1, & h2, & h3': {
		fontFamily: 'var(--font-display), Arial, sans-serif',
	},
	'& h1': {
		fontSize: 'clamp(48px, 6.4vw, 86px)',
		lineHeight: '0.99',
		letterSpacing: '-4px',
		fontWeight: '600',
	},
	'& h2': {
		fontSize: 'clamp(36px, 4vw, 54px)',
		lineHeight: '1.05',
		letterSpacing: '-2px',
		fontWeight: '600',
	},
	'& h3': {
		fontSize: '23px',
		lineHeight: '1.2',
		letterSpacing: '-0.6px',
	},
	'& .wrap': {
		maxWidth: '1320px',
		padding: '0 48px',
		margin: 'auto',
	},
	'& .nav': {
		height: '90px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		borderBottom: '1px solid var(--line)',
	},
	'& .brand': {
		display: 'flex',
		alignItems: 'center',
		gap: '9px',
		font: '700 29px var(--font-display)',
	},
	'& .brand img': {
		width: '36px',
		height: '36px',
	},
	'& .brand span': {
		font: '14px var(--font-family)',
		borderLeft: '1px solid #bac2b6',
		paddingLeft: '17px',
		marginLeft: '7px',
	},
	'& .navlinks': {
		display: 'flex',
		alignItems: 'center',
		gap: '28px',
		fontSize: '14px',
	},
	'& .button': {
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '22px',
		border: '0',
		borderRadius: '6px',
		background: 'var(--green)',
		color: 'white',
		padding: '14px 21px',
		fontWeight: '600',
		fontSize: '14px',
		transition: 'background 0.15s,\n          transform 0.15s',
	},
	'& .button:hover': {
		background: '#325543',
		transform: 'translateY(-1px)',
	},
	'& .arrow': {
		fontSize: '21px',
		fontWeight: '400',
		lineHeight: '1',
	},
	'& .hero': {
		display: 'grid',
		gridTemplateColumns: '1.15fr 1fr',
		columnGap: '35px',
		rowGap: '26px',
		padding: '64px 0 50px',
		alignItems: 'center',
	},
	'& .hero h1': {
		gridColumn: '1',
		alignSelf: 'end',
		fontSize: 'clamp(48px, 5.8vw, 76px)',
	},
	'& .hero-art': {
		gridColumn: '2',
		gridRow: '1 / 3',
		margin: '0 -20px 0 -35px',
		alignSelf: 'center',
		position: 'relative',
	},
	'& #toggle-cloud-motion': {
		position: 'absolute',
		right: '10px',
		bottom: '0',
		border: '1px solid var(--line)',
		borderRadius: '5px',
		padding: '5px 9px',
		background: 'var(--paper)',
		color: 'var(--muted)',
		fontSize: '11px',
	},
	'& .hero-art svg': {
		display: 'block',
		width: '100%',
		height: 'auto',
	},
	'& .hero h1 span': {
		color: '#738645',
	},
	'& .hero-copy': {
		gridColumn: '1',
		alignSelf: 'start',
		paddingBottom: '6px',
		maxWidth: '510px',
	},
	'& .hero-copy p': {
		fontSize: '19px',
		lineHeight: '1.6',
		color: '#56615a',
		marginBottom: '25px',
	},
	'& .hero-actions': {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center',
		gap: '12px',
	},
	'& .hero-copy .text-link': {
		display: 'block',
		width: 'fit-content',
		marginTop: '17px',
		fontSize: '14px',
		borderBottom: '1px solid #aab3a3',
	},
	'& .showcase': {
		border: '1px solid #c7cebd',
		background: '#e7eadc',
		borderRadius: '13px',
		padding: '15px',
		boxShadow: '0 18px 45px #263a2210',
	},
	'& .example-tabs': {
		display: 'flex',
		gap: '8px',
		padding: '0 0 15px',
		alignItems: 'center',
	},
	'& .example-tabs button': {
		background: 'transparent',
		border: '1px solid transparent',
		borderRadius: '6px',
		padding: '10px 17px',
		fontSize: '14px',
		color: '#5d685a',
	},
	'& .example-tabs button[aria-pressed="true"]': {
		background: 'var(--green)',
		color: 'white',
	},
	'& .example-tabs button:hover': {
		borderColor: '#9bac91',
	},
	'& .app': {
		display: 'grid',
		gridTemplateColumns: '235px 1fr',
		minHeight: '400px',
		border: '1px solid #cbd1c6',
		borderRadius: '8px',
		overflow: 'hidden',
		background: 'white',
	},
	'& .studio': {
		padding: '23px 20px',
		background: '#f6f7f2',
		borderRight: '1px solid #e0e3d9',
	},
	'& .studio-brand': {
		fontSize: '14px',
		fontWeight: '700',
		display: 'flex',
		gap: '10px',
		alignItems: 'center',
	},
	'& .studio-icon': {
		display: 'grid',
		placeItems: 'center',
		background: '#dfe7d0',
		width: '29px',
		height: '29px',
		borderRadius: '7px',
	},
	'& .studio small': {
		display: 'block',
		color: '#788170',
		fontSize: '11px',
		margin: '28px 0 10px',
		letterSpacing: '0.6px',
		textTransform: 'uppercase',
	},
	'& .space': {
		padding: '9px 11px',
		fontSize: '13px',
		color: '#6b7565',
	},
	'& .space.active': {
		background: '#e4ead8',
		color: '#243c29',
		borderRadius: '5px',
		fontWeight: '600',
	},
	'& .studio-bottom': {
		borderTop: '1px solid #e0e3d9',
		marginTop: '30px',
		paddingTop: '16px',
		fontSize: '12px',
		color: '#788170',
	},
	'& .studio-bottom strong': {
		display: 'block',
		color: '#35432e',
		fontWeight: '500',
		marginTop: '6px',
	},
	'& .workspace': {
		minWidth: '0',
	},
	'& .appbar': {
		height: '58px',
		padding: '0 25px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		borderBottom: '1px solid #e9ece4',
		fontSize: '12px',
		color: '#798171',
	},
	'& .appbar strong': {
		color: '#394735',
		fontWeight: '500',
	},
	'& .live': {
		display: 'flex',
		alignItems: 'center',
		gap: '7px',
		fontSize: '11px',
	},
	'& .live:before': {
		content: '""',
		width: '6px',
		height: '6px',
		borderRadius: '100%',
		background: '#5f955c',
	},
	'& .workbody': {
		display: 'grid',
		gridTemplateColumns: '0.85fr 1.15fr',
		gap: '28px',
		padding: '28px',
	},
	'& .request-label': {
		fontSize: '11px',
		color: '#808776',
		marginBottom: '13px',
	},
	'& .request': {
		fontSize: '20px',
		fontFamily: 'var(--font-display)',
		lineHeight: '1.4',
		letterSpacing: '-0.4px',
	},
	'& .pipeline': {
		marginTop: '22px',
		display: 'grid',
		gap: '9px',
		fontSize: '12px',
	},
	'& .pipeline div': {
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
	},
	'& .check': {
		fontSize: '11px',
		width: '19px',
		height: '19px',
		borderRadius: '50%',
		background: '#edf3e5',
		color: '#477349',
		display: 'grid',
		placeItems: 'center',
	},
	'& .trigger': {
		fontSize: '11px',
		marginTop: '21px',
		color: '#757d6b',
		borderTop: '1px solid #e4e8de',
		paddingTop: '12px',
	},
	'& .output': {
		border: '1px solid #dfe4d7',
		borderRadius: '8px',
		overflow: 'hidden',
		boxShadow: '0 5px 18px #2d412409',
		minWidth: '0',
	},
	'& .output-bar': {
		background: '#f6f8f0',
		padding: '10px 14px',
		fontSize: '11px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		color: '#6b7760',
	},
	'& .mode-tabs': {
		display: 'flex',
		gap: '3px',
	},
	'& .mode-tabs button': {
		fontSize: '11px',
		padding: '4px 8px',
		background: 'transparent',
		border: '0',
		borderRadius: '4px',
		color: '#738168',
	},
	'& .mode-tabs button[aria-pressed="true"]': {
		background: 'white',
		boxShadow: '0 1px 4px #17240a19',
		color: '#233b2a',
	},
	'& .output-content': {
		padding: '20px',
	},
	'& .output-sub': {
		fontSize: '11px',
		color: '#7a8174',
		margin: '4px 0 18px',
	},
	'& .data-row': {
		display: 'flex',
		justifyContent: 'space-between',
		gap: '15px',
		fontSize: '12px',
		padding: '11px 0',
		borderTop: '1px solid #e9ece3',
	},
	'& .data-row span:last-child': {
		whiteSpace: 'nowrap',
	},
	'& .output-foot': {
		fontSize: '11px',
		color: '#537045',
		background: '#eef4e5',
		padding: '10px 12px',
		borderRadius: '4px',
		marginTop: '12px',
	},
	'& .agent-prompt': {
		fontSize: '12px',
		background: '#f0f2e9',
		padding: '12px',
		borderRadius: '5px',
		marginBottom: '18px',
	},
	'& .agent-result': {
		fontSize: '14px',
		lineHeight: '1.7',
	},
	'& .agent-tool': {
		font: '10px/1.6 monospace',
		color: '#69765e',
		marginBottom: '10px',
		overflowWrap: 'anywhere',
	},
	'& .demo-caption': {
		fontSize: '12px',
		color: '#74806a',
		margin: '12px 0 0',
		textAlign: 'right',
	},
	'& .capabilities': {
		display: 'flex',
		justifyContent: 'space-between',
		gap: '20px',
		padding: '29px 15px',
		borderBottom: '1px solid var(--line)',
		fontSize: '13px',
		color: '#63705e',
	},
	'& .capabilities span': {
		display: 'flex',
		gap: '10px',
		alignItems: 'center',
	},
	'& .capabilities b': {
		fontSize: '17px',
		color: '#7c8d60',
		fontWeight: '400',
	},
	'& .reuse': {
		display: 'grid',
		gridTemplateColumns: '1fr 1.08fr',
		gap: '100px',
		alignItems: 'center',
		padding: '120px 0',
	},
	'& .section-copy p': {
		fontSize: '18px',
		color: '#66715f',
		lineHeight: '1.7',
		marginTop: '25px',
		maxWidth: '420px',
	},
	'& .section-copy .text-link': {
		display: 'inline-block',
		fontSize: '14px',
		borderBottom: '1px solid #829471',
		marginTop: '25px',
	},
	'& .library': {
		background: '#e9ecdf',
		border: '1px solid #d9dfce',
		borderRadius: '12px',
		padding: '30px',
	},
	'& .package': {
		background: 'white',
		border: '1px solid #d5ddc8',
		padding: '21px',
		borderRadius: '7px',
		display: 'flex',
		gap: '15px',
		alignItems: 'center',
		boxShadow: '0 5px 12px #2f452609',
	},
	'& .package-icon': {
		display: 'grid',
		placeItems: 'center',
		width: '42px',
		height: '44px',
		background: '#e6eed7',
		borderRadius: '6px',
		font: '24px var(--font-display)',
		color: '#637c44',
	},
	'& .package strong': {
		display: 'block',
		fontSize: '15px',
	},
	'& .package small': {
		color: '#89927e',
		fontSize: '12px',
	},
	'& .branches': {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
		gap: '17px',
		marginTop: '35px',
		position: 'relative',
	},
	'& .branches:before': {
		content: '""',
		position: 'absolute',
		left: '25%',
		right: '25%',
		top: '-20px',
		borderTop: '1px solid #a9b899',
		height: '20px',
		borderLeft: '1px solid #a9b899',
		borderRight: '1px solid #a9b899',
	},
	'& .branches:after': {
		content: '""',
		position: 'absolute',
		height: '15px',
		top: '-35px',
		left: '50%',
		borderLeft: '1px solid #a9b899',
	},
	'& .client': {
		background: '#f9faf5',
		padding: '18px',
		border: '1px solid #d2dcc5',
		borderRadius: '6px',
		fontSize: '12px',
	},
	'& .client strong': {
		display: 'block',
		fontSize: '14px',
		marginBottom: '13px',
	},
	'& .client p': {
		color: '#7b876d',
		fontSize: '11px',
		marginTop: '7px',
	},
	'& .client .tag': {
		display: 'inline-block',
		background: '#e8eedf',
		padding: '3px 7px',
		borderRadius: '4px',
		marginTop: '13px',
		fontSize: '10px',
		color: '#5b7446',
	},
	'& .library-note': {
		fontSize: '12px',
		color: '#76836a',
		marginTop: '18px',
		textAlign: 'center',
	},
	'& .ownership': {
		background: 'var(--green)',
		color: '#f7f9ee',
		padding: '85px 0 90px',
	},
	'& .ownership-grid': {
		display: 'grid',
		gridTemplateColumns: '1fr 1.1fr',
		gap: '90px',
		alignItems: 'start',
	},
	'& .ownership h2': {
		maxWidth: '430px',
	},
	'& .ownership .section-copy p': {
		color: '#b5c7b8',
	},
	'& .access': {
		border: '1px solid #526c56',
		borderRadius: '9px',
		overflow: 'hidden',
	},
	'& .access-title': {
		padding: '18px 20px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		fontSize: '14px',
		background: '#2a493b',
	},
	'& .access-title span': {
		fontSize: '11px',
		color: '#bbcfb6',
	},
	'& .person': {
		display: 'grid',
		gridTemplateColumns: '32px 1fr auto',
		alignItems: 'center',
		gap: '12px',
		padding: '18px 20px',
		borderTop: '1px solid #45604b',
		fontSize: '13px',
	},
	'& .avatar': {
		background: '#62764f',
		color: '#f4f8e5',
		borderRadius: '50%',
		display: 'grid',
		placeItems: 'center',
		height: '30px',
		fontSize: '11px',
	},
	'& .person small': {
		display: 'block',
		color: '#a5bda6',
		fontSize: '11px',
	},
	'& .role': {
		fontSize: '11px',
		color: '#d6e6c8',
		border: '1px solid #6a805c',
		borderRadius: '4px',
		padding: '4px 8px',
	},
	'& .ownership-notes': {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
		gap: '35px',
		marginTop: '34px',
	},
	'& .ownership-notes h3': {
		fontSize: '17px',
		letterSpacing: '0',
	},
	'& .ownership-notes p': {
		fontSize: '13px',
		color: '#b5c7b8',
		marginTop: '9px',
	},
	'& .offer': {
		display: 'grid',
		gridTemplateColumns: '1.2fr 1fr',
		gap: '100px',
		padding: '100px 0',
		alignItems: 'center',
	},
	'& .offer p': {
		fontSize: '18px',
		color: '#65705f',
		marginTop: '25px',
		maxWidth: '450px',
	},
	'& .offer-card': {
		borderLeft: '1px solid #c8d2bb',
		paddingLeft: '40px',
	},
	'& .offer-card h3': {
		fontSize: '24px',
	},
	'& .offer-card ul': {
		padding: '0',
		listStyle: 'none',
		margin: '20px 0 28px',
		color: '#64705b',
		fontSize: '15px',
	},
	'& .offer-card li': {
		padding: '9px 0',
		borderBottom: '1px solid #dee2d5',
	},
	'& .offer-card li:before': {
		content: '"✓"',
		marginRight: '12px',
		color: '#698647',
	},
	'& [hidden]': {
		display: 'none',
	},
	'@media (min-width: 1500px)': {
		'& .hero': {
			paddingTop: '85px',
			paddingBottom: '65px',
		},
	},
	'@media (max-width: 1000px)': {
		'& .wrap': {
			padding: '0 30px',
		},
		'& .hero': {
			gap: '35px',
		},
		'& .hero h1': {
			fontSize: '56px',
			letterSpacing: '-3px',
		},
		'& .hero-copy p': {
			fontSize: '17px',
		},
		'& .app': {
			gridTemplateColumns: '175px 1fr',
		},
		'& .studio': {
			padding: '20px 12px',
		},
		'& .workbody': {
			gap: '20px',
			padding: '20px',
		},
		'& .reuse, & .ownership-grid, & .offer': {
			gap: '45px',
		},
		'& .capabilities': {
			fontSize: '11px',
		},
		'& .navlinks': {
			gap: '19px',
		},
	},
	'@media (max-width: 760px)': {
		'& .wrap': {
			padding: '0 20px',
		},
		'& .nav': {
			height: '76px',
		},
		'& .brand': {
			fontSize: '25px',
		},
		'& .brand span': {
			fontSize: '12px',
			paddingLeft: '10px',
			marginLeft: '0',
		},
		'& .brand img': {
			width: '31px',
			height: '31px',
		},
		'& .navlinks > a:not(.button)': {
			display: 'none',
		},
		'& .navlinks .button': {
			fontSize: '12px',
			padding: '10px 12px',
			gap: '10px',
		},
		'& .hero': {
			gridTemplateColumns: '1fr',
			padding: '45px 0 32px',
			gap: '24px',
		},
		'& .hero h1': {
			fontSize: '46px',
			letterSpacing: '-2px',
			maxWidth: '530px',
		},
		'& .hero-art': {
			gridColumn: '1',
			gridRow: '3',
			margin: '-15px auto -10px',
			width: '100%',
			maxWidth: '450px',
		},
		'& .hero-copy': {
			maxWidth: '490px',
		},
		'& .hero-copy p': {
			fontSize: '17px',
			marginBottom: '20px',
		},
		'& .hero-copy .text-link': {
			display: 'inline-block',
			marginLeft: '15px',
			marginTop: '0',
			fontSize: '12px',
		},
		'& .showcase': {
			padding: '8px',
		},
		'& .example-tabs': {
			gap: '2px',
			paddingBottom: '8px',
			justifyContent: 'space-between',
		},
		'& .example-tabs button': {
			padding: '9px 8px',
			fontSize: '11px',
		},
		'& .app': {
			gridTemplateColumns: '1fr',
		},
		'& .studio': {
			display: 'none',
		},
		'& .appbar': {
			padding: '0 15px',
			height: '45px',
			fontSize: '11px',
		},
		'& .workbody': {
			gridTemplateColumns: '1fr',
			padding: '20px',
			gap: '22px',
		},
		'& .request': {
			fontSize: '21px',
		},
		'& .pipeline': {
			gridTemplateColumns: '1fr',
			gap: '7px',
			marginTop: '14px',
		},
		'& .trigger': {
			marginTop: '14px',
		},
		'& .output-content': {
			minHeight: '225px',
		},
		'& .demo-caption': {
			fontSize: '10px',
			marginTop: '8px',
		},
		'& .capabilities': {
			display: 'grid',
			gridTemplateColumns: '1fr 1fr',
			padding: '22px 0',
			gap: '15px',
			fontSize: '11px',
		},
		'& .reuse': {
			gridTemplateColumns: '1fr',
			padding: '65px 0',
			gap: '30px',
		},
		'& .section-copy p': {
			fontSize: '16px',
			marginTop: '20px',
		},
		'& .library': {
			padding: '20px',
		},
		'& .client': {
			padding: '12px',
		},
		'& .ownership': {
			padding: '60px 0',
		},
		'& .ownership-grid': {
			gridTemplateColumns: '1fr',
			gap: '30px',
		},
		'& .ownership-notes': {
			gap: '22px',
		},
		'& .offer': {
			gridTemplateColumns: '1fr',
			gap: '30px',
			padding: '65px 0',
		},
		'& .offer p': {
			fontSize: '16px',
			marginTop: '20px',
		},
		'& .offer-card': {
			paddingLeft: '0',
			borderLeft: '0',
		},
		'& .person': {
			padding: '16px 13px',
		},
		'& .access-title': {
			padding: '16px 13px',
		},
		'& .role': {
			fontSize: '10px',
		},
		'& .hero-copy .button': {
			gap: '12px',
			padding: '13px 16px',
		},
	},
	'@media (prefers-reduced-motion: reduce)': {
		'& *': {
			transition: 'none',
		},
	},
	'& .output-content h2': {
		fontSize: '20px',
		letterSpacing: '-0.6px',
	},
}
